// extracted by mini-css-extract-plugin
module.exports = {"scoreExplanationList":"styles_scoreExplanationList__3p_ID","description":"styles_description__3tB9G"};